/*
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-06 16:36:58
 * @LastEditTime: 2021-03-03 11:13:12
 */
import Layout from '@/layout'
import {
    asyncRouter, constantRouter
} from '@/router'

function hasPermission(roles, route) {
    if (route.meta && route.meta.role) {
        return roles.some(role => route.meta.role.indexOf(role) >= 0)
    } else {
        return true
    }
}

// 添加实例
export function generaMenu(routes, data) {
    data.forEach(item => {
        const menu = {
            path: item.path === '#' ? item.id + '_key' : item.path,
            component: item.component === 'Layout' ? Layout : () => import(`@/views${item.component}`),
            hidden: item.hidden,
            redirect: item.redirect,
            children: [],
            meta: item.meta
        }

        if (item.children) {
            generaMenu(menu.children, item.children)
        }
        routes.push(menu)
    })
}

const state = {
    routes: [],
    addRoutes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = (routes)
    }
}

const actions = {
    generateRoutes({
        commit
    }, data) {
        return new Promise(resolve => {
            let uType = (JSON.parse(localStorage.getItem('userInfo'))).user_type
            const accessRouter = asyncRouter.filter((v) => {
                if(v.path === '*'){
                    return true
                }
                if(v.meta.role.indexOf(uType) !== -1){
                    return true
                }else{
                    return false
                }
            })
            commit('SET_ROUTES', constantRouter.concat(accessRouter))
            resolve(constantRouter.concat(accessRouter))

        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}